/**
 * Util for Fastly image resizing
 *
 * @param {string} imageUrl - image
 * @param {{width?: number, height?: number}} Dimensions - for sizing
 */
export function thumbnail(imageUrl, { width, height }) {
  let url = new URL(imageUrl, "https://static.scientificamerican.com");

  if (width || height) {
    // remove existing w/h params
    url.searchParams.delete("w");
    url.searchParams.delete("h");
  }

  if (width) {
    url.searchParams.append("w", width);
  }
  if (height) {
    url.searchParams.append("h", height);
  }

  return url.toString();
}
